import { render, staticRenderFns } from "./TheModalTemplateMsgBody.vue?vue&type=template&id=de7b4f9e&scoped=true"
import script from "./TheModalTemplateMsgBody.vue?vue&type=script&lang=js"
export * from "./TheModalTemplateMsgBody.vue?vue&type=script&lang=js"
import style0 from "./TheModalTemplateMsgBody.vue?vue&type=style&index=0&id=de7b4f9e&prod&lang=css"
import style1 from "./TheModalTemplateMsgBody.vue?vue&type=style&index=1&id=de7b4f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7b4f9e",
  null
  
)

export default component.exports